import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "pad15",
  style: {"height":"90vh"}
}
const _hoisted_2 = { class: "h20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  class: "ofs RoomHistoryDetailModalScroll noscroll",
  style: {"height":"calc(90vh - 50px)"}
}
const _hoisted_6 = {
  class: "title mc",
  style: {"width":"260px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs24 centered",
  style: {"color":"#696969"}
}, "入力済みフォーム作成", -1)
const _hoisted_8 = {
  class: "mc centered",
  style: {"justify-content":"center","display":"flex"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = {
  class: "text pad20",
  style: {"color":"#696969"}
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = { class: "centered mt40" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "fs13 fw600" }, "公開ページを選択", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "fs12" }, "アンケートで利用する公開ページを選択してください。", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = {
  key: 1,
  class: ""
}
const _hoisted_20 = {
  key: 0,
  class: "fl mt10"
}
const _hoisted_21 = {
  key: 1,
  class: "fr"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["src"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["src"]
const _hoisted_26 = { key: 2 }
const _hoisted_27 = {
  key: 2,
  class: "fr"
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "fl" }, "  作成しています", -1)
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_32 = {
  key: 3,
  class: "fl w40 lskyblueBg rad20 pad10"
}
const _hoisted_33 = { key: 4 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = {
  key: 0,
  class: "fl w40 lskyblueBg rad20 pad10"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "centered fs18 fw600 mt20" }, "共通でメール内容を作成", -1)
const _hoisted_37 = {
  key: 1,
  class: "fl w40 lskyblueBg rad20 pad10 ofs mb40"
}
const _hoisted_38 = { class: "fl w60 pad20" }
const _hoisted_39 = { class: "w100" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", null, "選択中のアドレス帳グループ:", -1)
const _hoisted_44 = {
  class: "w100 pad10 border rad10",
  style: {"border":"1px solid #ddd"}
}
const _hoisted_45 = { class: "w100" }
const _hoisted_46 = { class: "fl" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "dblueBg padw5 rad8 mt2 fs12 fw600 mr10" }, "グループ", -1)
const _hoisted_48 = {
  key: 0,
  class: "mt3 ml5"
}
const _hoisted_49 = { class: "fl" }
const _hoisted_50 = { class: "fs16 fw600 mt3" }
const _hoisted_51 = {
  key: 0,
  class: "fs12 grey"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_54 = { key: 1 }
const _hoisted_55 = {
  key: 0,
  class: "posAb fs10 lgreyBg dgrey rad10 centered fw600",
  style: {"height":"20px","line-height":"20px","width":"45px","top":"40px"}
}
const _hoisted_56 = {
  class: "posAb",
  style: {"width":"18px","top":"-5px","right":"-5px"}
}
const _hoisted_57 = ["src", "onClick"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("p", { class: "fs13 fw600" }, "フォームに埋めておく内容を入力", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("p", { class: "fs12" }, [
  /*#__PURE__*/_createTextVNode(" フォームを埋めておくと、お相手に提示する際にその項目は非表示になります。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" また、未入力のフォーム項目がない場合、フォームを自動的にスキップされます。 ")
], -1)
const _hoisted_64 = {
  key: 0,
  class: "fs12"
}
const _hoisted_65 = { class: "w100" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb15" }, null, -1)
const _hoisted_67 = { key: 1 }
const _hoisted_68 = {
  key: 0,
  class: "mt10"
}
const _hoisted_69 = { key: 0 }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("p", { class: "padw5 fl fs13" }, "宛先:", -1)
const _hoisted_71 = { class: "fl fs14 fw600 arial mt5" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_73 = { key: 0 }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("p", { class: "padw5 fl fs13 mt3" }, "CC:", -1)
const _hoisted_75 = {
  key: 1,
  class: "w100 posRe"
}
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_77 = { class: "fr mt10" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", {
  for: `is_only_public_room_`,
  class: "fs13 pointer"
}, " 限定公開ページを作成しない", -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_81 = {
  key: 2,
  class: ""
}
const _hoisted_82 = { class: "fr" }
const _hoisted_83 = {
  key: 0,
  class: "fs14 mb20"
}
const _hoisted_84 = { class: "fl mt10" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "centered" }, [
  /*#__PURE__*/_createTextVNode(" URLをコピーまたは、QRコードを保存しておいてください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" このモーダルを閉じると設定内容はリセットされます。 ")
], -1)
const _hoisted_87 = {
  key: 1,
  class: "fs14 centered mb20"
}
const _hoisted_88 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_91 = {
  key: 2,
  class: "fs14 centered mb20"
}
const _hoisted_92 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_95 = { key: 3 }
const _hoisted_96 = {
  key: 0,
  class: "fs14 centered mb20"
}
const _hoisted_97 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_100 = {
  key: 4,
  class: "centering",
  style: {"justify-content":"space-around"}
}
const _hoisted_101 = { class: "fs14 centered mt40 mb20" }
const _hoisted_102 = { class: "fs16 fw600" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_105 = {
  key: 5,
  class: "centering",
  style: {"justify-content":"space-around"}
}
const _hoisted_106 = { class: "fw600 mt10 fs20" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_MdProgressSpinner = _resolveComponent("MdProgressSpinner")!
  const _component_LeftPanelSettingsContent = _resolveComponent("LeftPanelSettingsContent")!
  const _component_AddCommentToMail = _resolveComponent("AddCommentToMail")!
  const _component_TemplatesContent = _resolveComponent("TemplatesContent")!
  const _component_PargSectionsContent = _resolveComponent("PargSectionsContent")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_FormFieldContent = _resolveComponent("FormFieldContent")!
  const _component_ChipButton = _resolveComponent("ChipButton")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_SendMailContent = _resolveComponent("SendMailContent")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_UrlWithQRcodeContent = _resolveComponent("UrlWithQRcodeContent")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "CreateFeedbackModal",
    "content-class": "rad10 with_white_bg shadowContent modalWide noscroll",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: _normalizeClass(`pointer fs12 ${
                                ['form', 'mail'].includes(_ctx.viewType) ? `fw600 borderGrey padw5` : `llgreyBg padw6`
                            }`),
                style: {"border-radius":"10px 0 0 10px"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeViewType(`form`)))
              }, " 事前埋め調整 ", 2),
              _createElementVNode("div", {
                class: _normalizeClass(`pointer fs12 ${
                                !['form', 'mail'].includes(_ctx.viewType) ? `fw600 borderGrey padw5` : `llgreyBg padw6`
                            }`),
                style: {"border-radius":"0 10px 10px 0"},
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeViewType(`parg`)))
              }, " ステップ調整 ", 2),
              _hoisted_9
            ]),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.step == 0)
              ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                  (_ctx.selectedPubRoom)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "submit",
                        class: "fr pointer centered circle_button skyblueBg fs14 rad8 mr20",
                        style: {"height":"50px"},
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selectPubRoomEnd && _ctx.selectPubRoomEnd(...args)))
                      }, " 選択 "))
                    : _createCommentVNode("", true),
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _hoisted_16,
                    (_ctx.defaultPubName)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "fr pointer skyblue",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.deselect && _ctx.deselect(...args)))
                        }, "選択をはずす"))
                      : _createCommentVNode("", true),
                    _createVNode(_component_SelectTag, {
                      name: "connect_open_page",
                      id: "connect_open_page",
                      class: "fs14 roundForm",
                      style: {"min-width":"130px","height":"50px"},
                      options: _ctx.publics || [],
                      defaultOption: _ctx.defaultPubName,
                      needUnselect: true,
                      isDisabled: false,
                      onSelectValue: _ctx.selectConnectPage
                    }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                    _hoisted_17
                  ]),
                  _hoisted_18
                ]))
              : (_ctx.step == 1)
                ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
                    (_ctx.defaultPubName)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("div", {
                            class: "pointer skyblue fs13",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.restart && _ctx.restart(...args)))
                          }, "< 作成し直す")
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          (_ctx.viewType == `form`)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                false
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "underline fs13 fl mr20 mt13",
                                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.generateUrl && _ctx.generateUrl(...args)))
                                    }, "URLのみを生成"))
                                  : _createCommentVNode("", true),
                                (!_ctx.loading)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "submit",
                                      class: _normalizeClass(`${
                                        _ctx.Util.isPresent(this.members) || _ctx.selectedClg ? `skyblueBg` : `lgreyBg`
                                    } pointer centered circle_button fs12 rad8 mr20`),
                                      style: {"height":"40px"},
                                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.createParentRoom(false)))
                                    }, " 日程調整を開始 ", 2))
                                  : _createCommentVNode("", true),
                                (!_ctx.loading)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      type: "submit",
                                      class: _normalizeClass(`${
                                        _ctx.Util.isPresent(this.members) || _ctx.selectedClg ? `skyblueBg` : `lgreyBg`
                                    } pointer centered circle_button fs12 rad8 mr20`),
                                      style: {"height":"40px","padding":"5px 20px"},
                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.createParentRoom(true)))
                                    }, [
                                      _createElementVNode("img", {
                                        src: _ctx.$getAssetImageUrl(`/assets/icons/sendMessage.png`),
                                        width: "24",
                                        height: "24",
                                        class: ""
                                      }, null, 8, _hoisted_23),
                                      _createTextVNode(" メールを作成し日程調整を開始 ")
                                    ], 2))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_ctx.viewType == `mail`)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  (!_ctx.loading)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "submit",
                                        class: _normalizeClass(`${
                                        _ctx.Util.isPresent(this.members) ? `skyblueBg` : `lgreyBg`
                                    } pointer centered circle_button fs14 rad8 mr20 fw600`),
                                        style: {"height":"40px","padding":"5px 20px"},
                                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.sendAndCreate && _ctx.sendAndCreate(...args)))
                                      }, [
                                        _createElementVNode("img", {
                                          src: _ctx.$getAssetImageUrl(`/assets/icons/sendMessage.png`),
                                          width: "24",
                                          height: "24",
                                          class: "mr5",
                                          style: {"margin-top":"-3px"}
                                        }, null, 8, _hoisted_25),
                                        _createTextVNode(" 送信 ")
                                      ], 2))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.viewType == `parg`)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    (
                                        !_ctx.loading &&
                                        _ctx.Util.isPresent(_ctx.rcm.userList) &&
                                        (_ctx.rcm.fixers.length == 1 || _ctx.rcm.parg.use_ai_fix)
                                    )
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "submit",
                                          class: _normalizeClass(`${
                                        _ctx.Util.isPresent(this.members) || _ctx.selectedClg ? `skyblueBg` : `lgreyBg`
                                    } pointer centered circle_button fs12 rad8 mr20`),
                                          style: {"height":"40px"},
                                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.createParentRoomGroup && _ctx.createParentRoomGroup(...args)))
                                        }, " 日程調整を開始 ", 2))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          (_ctx.viewType == `mail`)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createVNode(_component_MdProgressSpinner, {
                                  width: `30`,
                                  class: "fl",
                                  style: {"margin-top":"-8px"}
                                }),
                                _hoisted_29
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _createVNode(_component_MdProgressSpinner, {
                                  width: `30`,
                                  class: "fl",
                                  style: {"margin-top":"-8px"}
                                })
                              ]))
                        ])),
                    _hoisted_31,
                    ([`form`, `parg`].includes(_ctx.viewType))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createVNode(_component_LeftPanelSettingsContent, {
                            members: [],
                            currentMember: _ctx.currentMember,
                            editOrNewForm: _ctx.editOrNewForm,
                            viewType: _ctx.viewType,
                            onAddAttendee: _ctx.addAttendee,
                            onSelectContactListGroup: _ctx.selectContactListGroup
                          }, null, 8, ["currentMember", "editOrNewForm", "viewType", "onAddAttendee", "onSelectContactListGroup"])
                        ]))
                      : (_ctx.viewType == `mail`)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createElementVNode("div", {
                              class: "fl pointer",
                              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.backToSelectMember && _ctx.backToSelectMember(...args)))
                            }, "< 送信先選択に戻る"),
                            _hoisted_34,
                            false
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  _hoisted_36,
                                  _createVNode(_component_AddCommentToMail, {
                                    ref: "AddCommentToMail",
                                    class: "mt20",
                                    tmp: _ctx.tmp,
                                    showSubject: true,
                                    onInputMemo: _ctx.inputTemplateContent,
                                    onInputSubject: _ctx.inputSubject
                                  }, null, 8, ["tmp", "onInputMemo", "onInputSubject"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_TemplatesContent, {
                                      class: "mt20",
                                      onDecideTemplate: _ctx.decideTemplate,
                                      onUpdateSelectedRoom: _ctx.updateSelectedRoom
                                    }, null, 8, ["onDecideTemplate", "onUpdateSelectedRoom"])
                                  ])
                                ]))
                          ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        (_ctx.viewType == `parg`)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _createVNode(_component_PargSectionsContent)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              ((_ctx.selectedClg?.total_num || 0) > _ctx.ContactListGroup.DISPLAY_TOTAL_NUM)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    _hoisted_43,
                                    _createElementVNode("div", _hoisted_44, [
                                      _createElementVNode("div", _hoisted_45, [
                                        _createElementVNode("div", _hoisted_46, [
                                          _hoisted_47,
                                          (_ctx.selectedClg.total_num)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_ctx.selectedClg?.total_num || 0) + "人 ", 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_49, [
                                          _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.selectedClg.name), 1),
                                          (_ctx.selectedClg.private_memo)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(_ctx.selectedClg.private_memo), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_52
                                      ]),
                                      _hoisted_53
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.members, (mem, memindex) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "fl mr10 posRe mb20",
                                        key: memindex
                                      }, [
                                        (mem.user_id == _ctx.rcm.currentSendMem?.user_id)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_55, " 選択中 "))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_56, [
                                          _createElementVNode("img", {
                                            src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                                            width: "18",
                                            height: "18",
                                            class: "fr pointer",
                                            onClick: ($event: any) => (_ctx.deleteSendUser(mem))
                                          }, null, 8, _hoisted_57)
                                        ]),
                                        _createVNode(_component_UserIcon, {
                                          member: mem,
                                          width: 45,
                                          canEdit: false,
                                          updateSelf: false,
                                          showTooltip: true,
                                          class: "pointer",
                                          onClickImage: ($event: any) => (_ctx.selectSendUser(mem))
                                        }, null, 8, ["member", "onClickImage"])
                                      ]))
                                    }), 128))
                                  ]))
                            ])),
                        _hoisted_58
                      ]),
                      _hoisted_59,
                      (_ctx.viewType == `form`)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            ((_ctx.selectedClg?.total_num || 0) < 10)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                  _hoisted_62,
                                  _hoisted_63,
                                  (_ctx.member)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_64, "メールアドレス・お名前は自動で埋まります。"))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_65, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field, fieldindex) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: _normalizeClass(`w100 mt20 ${field.hideField ? `nodisp` : ``}`),
                                        key: `${fieldindex}${_ctx.systemUpdatedAt}`
                                      }, [
                                        _createVNode(_component_FormFieldContent, {
                                          field: field,
                                          fieldindex: fieldindex + 2,
                                          editable: false,
                                          updateFromChild: _ctx.updateFromChild
                                        }, null, 8, ["field", "fieldindex", "updateFromChild"]),
                                        _hoisted_66
                                      ], 2))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_ctx.viewType == `mail`)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                              (_ctx.currentMail)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                    (_ctx.rcm.currentSendMem && (_ctx.selectedClg?.total_num || 0) < 10)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                          _hoisted_70,
                                          _createElementVNode("p", _hoisted_71, _toDisplayString(_ctx.rcm.currentSendMem.email), 1),
                                          _createElementVNode("p", {
                                            class: "fr pointer fs13",
                                            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.addCc && _ctx.addCc(...args)))
                                          }, _toDisplayString(_ctx.showCc ? `CC入力欄を非表示` : `CC入力欄を表示`), 1),
                                          _hoisted_72,
                                          (
                                                _ctx.rcm.currentSendMem.cc_emails?.length > 0 &&
                                                _ctx.rcm.currentSendMem.cc_emails.split(`,`).length > 0
                                            )
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                                _hoisted_74,
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rcm.currentSendMem.cc_emails.split(`,`), (email, emailindex) => {
                                                  return (_openBlock(), _createBlock(_component_ChipButton, {
                                                    key: `${emailindex}${_ctx.rcm.currentSendMem.cc_emails.length}`,
                                                    name: `${email}`,
                                                    returnVal: email,
                                                    onDelete: ($event: any) => (_ctx.deleteCcEmail(email)),
                                                    color: `988b81`,
                                                    class: "mr5 mb4"
                                                  }, null, 8, ["name", "returnVal", "onDelete"]))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.showCc)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                                _createVNode(_component_TextfieldTag, {
                                                  placeholder: `CC: (Enterで追加)`,
                                                  style: {"height":"50px","padding":"0 20px"},
                                                  class: "fl fs14 roundForm mw100 rad20 mt20",
                                                  value: _ctx.currentMemCcEmails,
                                                  onInputValue: _ctx.inputCc,
                                                  onEnterPressed: _ctx.enterCc
                                                }, null, 8, ["placeholder", "value", "onInputValue", "onEnterPressed"]),
                                                (
                                                    _ctx.Util.isPresent(_ctx.currentMemCcEmails) && _ctx.Util.validateEmail(_ctx.currentMemCcEmails)
                                                )
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 0,
                                                      class: "posAb fs12 fw600 dblueBg rad8 padw5 pointer",
                                                      style: {"right":"20px","top":"32px"},
                                                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.enterCc && _ctx.enterCc(...args)))
                                                    }, " 追加 "))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _hoisted_76,
                                    _createVNode(_component_SendMailContent, {
                                      mf: _ctx.currentMail,
                                      onUpdateMail: _ctx.updateMail
                                    }, null, 8, ["mf", "onUpdateMail"]),
                                    _createElementVNode("div", _hoisted_77, [
                                      _createVNode(_component_CheckboxTag, {
                                        value: ``,
                                        name: `is_only_public_room`,
                                        checked: _ctx.currentMail.is_send_only_public_room,
                                        prefix: `is_only_public_room`,
                                        onClickCheckbox: _ctx.clickChangeSendOnlyPublicRoom,
                                        style: {"margin-left":"1px"}
                                      }, null, 8, ["checked", "onClickCheckbox"]),
                                      _createTextVNode("   "),
                                      _hoisted_78
                                    ]),
                                    _hoisted_79
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                    ]),
                    _hoisted_80
                  ]))
                : (_ctx.step == 2)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: _normalizeClass(`${
                                    _ctx.Util.isPresent(_ctx.members) ? `skyblueBg` : `lgreyBg`
                                } pointer centered circle_button  fs12 rad8 mr20`),
                          style: {"height":"40px"},
                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.resetRooms && _ctx.resetRooms(...args)))
                        }, " 別の日程調整を作成 ", 2)
                      ]),
                      (_ctx.rcm.createType == `only_url`)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                            _createElementVNode("div", _hoisted_84, [
                              _createElementVNode("div", {
                                class: "pointer skyblue fs13",
                                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.restart && _ctx.restart(...args)))
                              }, "< 作成し直す")
                            ]),
                            _hoisted_85,
                            _hoisted_86
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.rcm.createType == `send_mail`)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                            _createTextVNode(" それぞれの調整ページを作成し、メールを送信しました。"),
                            _hoisted_88,
                            _createTextVNode(" 調整するお相手が確定しない場合、2日後と調整ページから終了する前日にリマインドメールが自動送信されます。"),
                            _hoisted_89,
                            _createTextVNode(" 「調整中」タブでもそれぞれの進捗を確認できます。"),
                            _hoisted_90
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.rcm.createType == `except_first_mail`)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                            _createTextVNode(" それぞれの調整ページを作成しました。"),
                            _hoisted_92,
                            _createTextVNode("メール等で以下のURLを貼り付けてご利用ください。"),
                            _hoisted_93,
                            _createTextVNode(" 調整するお相手が確定しない場合、2日後と調整ページから終了する前日にリマインドメールが自動送信されます。"),
                            _hoisted_94,
                            _createTextVNode(" 「調整中」タブでもそれぞれの進捗を確認できます。 ")
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_95, [
                            (_ctx.viewType == `parg`)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                  _createTextVNode(" ステップ調整を開始し、ステップ1のメンバーにメールを送信しました。"),
                                  _hoisted_97,
                                  _createTextVNode(" 調整がストップすると止まっているメンバー宛に自動でリマインドメールが送信されます。"),
                                  _hoisted_98,
                                  _createTextVNode(" 「ステップ調整」タブにある「調整中」タブでもそれぞれの進捗を確認できます。 ")
                                ]))
                              : _createCommentVNode("", true)
                          ])),
                      _hoisted_99,
                      (_ctx.requestId)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                            _createElementVNode("div", _hoisted_101, [
                              _createTextVNode(" リクエストID: "),
                              _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.requestId), 1)
                            ]),
                            _hoisted_103
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_104,
                      (_ctx.generatedRoomsDic)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generatedRoomsDic, (roomDic, roomindex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "mb20 w45 llgreyBg rad20 pad40",
                                key: roomindex
                              }, [
                                _createElementVNode("p", _hoisted_106, _toDisplayString(roomDic.member.name) + " 様", 1),
                                _hoisted_107,
                                _createVNode(_component_UrlWithQRcodeContent, {
                                  index: roomindex,
                                  url: roomDic.room_link
                                }, null, 8, ["index", "url"])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}